import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';

type AuthTestResult = {
  service: string;
  endpoint: string;
  success: boolean;
  message: string;
  timestamp: string;
  details?: any;
  isAuthenticated?: boolean;
  userName?: string;
  claimsCount?: number;
};

type AuthResponse = {
  isAuthenticated: boolean;
  userName: string | null;
  claims: Array<{ type: string; value: string }>;
};

@Component({
  selector: 'app-auth-tests',
  templateUrl: './auth-tests.component.html',
  styleUrls: ['./auth-tests.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthTestsComponent implements OnDestroy {
  webApiBaseUrl = environment.dotNetApiUrl;
  reportingBaseUrl = environment.reportingServiceUrl;

  // Individual test loading states
  webApiAuthLoading = false;
  reportingAuthLoading = false;

  // Individual test results
  webApiAuthResult: AuthTestResult | null = null;
  reportingAuthResult: AuthTestResult | null = null;

  // Subscription management
  private subscriptions: Subscription[] = [];

  constructor(
    private httpClient: HttpClient,
  ) {}

  ngOnDestroy(): void {
    // Clean up all subscriptions to prevent memory leaks
    this.subscriptions.forEach(subscription => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
    this.subscriptions = [];
  }

  testWebApiAuth(): void {
    this.webApiAuthLoading = true;
    this.webApiAuthResult = null; // Clear previous result
    const url = `${this.webApiBaseUrl}/test/auth`;

    const subscription = this.httpClient
        .get<AuthResponse>(url)
        .subscribe({
        next: (response) => {
          this.webApiAuthResult = {
            service: 'WebAPI',
            endpoint: '/test/auth',
            success: true,
            message: 'Authentication test completed successfully',
            timestamp: new Date().toISOString(),
            details: response,
            isAuthenticated: response.isAuthenticated,
            userName: response.userName,
            claimsCount: response.claims ? response.claims.length : 0
          };
                this.webApiAuthLoading = false;
            },
            error: (error) => {
                this.webApiAuthResult = {
                    service: 'WebAPI',
                    endpoint: '/test/auth',
                    success: false,
                    message: `Error: ${error.message || 'Unknown error'}`,
                    timestamp: new Date().toISOString(),
                    details: error
                };
                this.webApiAuthLoading = false;
            }
        });

    this.subscriptions.push(subscription);
  }

  testReportingAuth(): void {
    this.reportingAuthLoading = true;
    this.reportingAuthResult = null; // Clear previous result
    const url = `${this.reportingBaseUrl}/test/auth`;

    const subscription = this.httpClient
        .get<AuthResponse>(url)
        .subscribe({
        next: (response) => {
          this.reportingAuthResult = {
            service: 'Reporting',
            endpoint: '/test/auth',
            success: true,
            message: 'Authentication test completed successfully',
            timestamp: new Date().toISOString(),
            details: response,
            isAuthenticated: response.isAuthenticated,
            userName: response.userName,
            claimsCount: response.claims ? response.claims.length : 0
          };
                this.reportingAuthLoading = false;
            },
            error: (error) => {
                this.reportingAuthResult = {
                    service: 'Reporting',
                    endpoint: '/test/auth',
                    success: false,
                    message: `Error: ${error.message || 'Unknown error'}`,
                    timestamp: new Date().toISOString(),
                    details: error
                };
                this.reportingAuthLoading = false;
            }
        });

    this.subscriptions.push(subscription);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/auth-tests/auth-tests.component.ts